export default __webpack_public_path__ + "static/media/03ddf6403bbf6e2b5815e806489b4fd91581602597932.6bc33cf6.webp";